<div class="layout-topbar">
    <div class="top-menu-button-container">
        <button #menubutton class="p-link layout-menu-button layout-topbar-button"
            (click)="layoutService.onMenuToggle()">
            <i class="pi pi-bars"></i>
        </button>
        <!-- <div class="setting-menu">
            <p-menu #menu [model]="menuItems" [popup]="true"></p-menu>
            <button pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars" label="Show"></button>
        </div> -->
    </div>
    <div class="top-menu-button-container">
        <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button"
            (click)="layoutService.showProfileSidebar()">
            <i class="pi pi-ellipsis-v"></i>
        </button>

    </div>

    <div #topbarmenu class="layout-topbar-menu"
        [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">
        <div class="logged-in-container-inner" *ngIf="userName">
            <i class="pi pi-user"></i>
            <div class="spacer"></div>
            <span class="logged-in-username">{{userName}}</span>
        </div>
        <div class="setting-menu hide-cog-button">
            <p-menu #menu [model]="menuItems" [popup]="true"></p-menu>
            <p-button (click)="menu.toggle($event)" icon="pi pi-cog" [rounded]="true" [text]="true"
                severity="secondary "></p-button>
        </div>
        <div class="hide-desktop-menu-buttons">
            <p-button label="Log out" (click)="logoutSelected()" class="hide-logout-button hide-top-menu-button" [text]="true" icon="pi pi-sign-out" severity="secondary"></p-button>
            <p-button label="Reset password" (click)="resetPasswordClicked();" class="hide-password-reset-button hide-top-menu-button" [text]="true" icon="pi pi-lock" severity="secondary"></p-button>
        </div>
    </div>
</div>